var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6193 0.501358C10.9835 0.480614 11.3189 0.699169 11.447 1.04074L13.7442 7.16668H16.5C16.9603 7.16668 17.3334 7.53977 17.3334 8.00001C17.3334 8.46025 16.9603 8.83334 16.5 8.83334H13.1667C12.8193 8.83334 12.5084 8.61787 12.3864 8.29261L10.8261 4.13171L8.14181 14.8688C8.05333 15.2227 7.74495 15.4779 7.38074 15.4987C7.01653 15.5194 6.68117 15.3009 6.55308 14.9593L4.25585 8.83334H1.50002C1.03978 8.83334 0.666687 8.46025 0.666687 8.00001C0.666687 7.53977 1.03978 7.16668 1.50002 7.16668H4.83335C5.18072 7.16668 5.49166 7.38215 5.61363 7.70741L7.17397 11.8683L9.85824 1.13123C9.94671 0.777324 10.2551 0.522103 10.6193 0.501358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.33b78a1d3fdc69ce75088bbc195c465b.svg";
export { ForwardRef as ReactComponent };